import { Component } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
import { translations } from '@shared/utils/translations';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: 'footer.component.html',
    styleUrl: 'footer.component.scss',
})
export class FooterComponent {
    protected readonly translations = translations;
    protected readonly environment = environment;
    protected readonly isDev = !environment.production;

    openLink(type: string): void {
        let url: string;

        switch (type) {
            case 'service':
                url = 'https://lichtblicke.de/helfen/spenderservice/';
                break;
            case 'impressum':
                url = 'https://lichtblicke.de/impressum/';
                break;
            case 'datenschutz':
                url = 'https://lichtblicke.de/datenschutz/';
                break;
            case 'meldestelle':
                url = 'https://lichtblicke.de/meldestelle/';
                break;
            default:
                return;
        }

        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
